export default __webpack_public_path__ + "static/media/mysubscriptions.061a13e5.svg";